<div class="modal-header bg-soft-info p-3">
    <h5 *ngIf="signatureOrInitial == true" class="modal-title" id="exampleModalLabel" i18n="@@">Submit Signature</h5>
    <h5 *ngIf="signatureOrInitial == false" class="modal-title" id="exampleModalLabel" i18n="@@">Submit Initials</h5>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="close-modal"
        (click)="close()"></button>
</div>
<div class="card-body p-3 justify-content-center flex">
    <div class="justify-content-center" style="display: flex;">
        <div style="display: flex; flex-wrap: wrap; width: {{widthPx}}px;  height: {{heightPx}}px;">
            <canvas #myCanvasSignature style="background-color:whitesmoke; border:solid 1px black; " width="{{widthPx}}"
                height="{{heightPx}}">
            </canvas>
            <div *ngIf="signatureUpload" class="border shadow text-center"
                style="background-color: #fff; position: relative; top:-{{heightImagePx}}px; ">
                <img [src]="signaturePNGTransform()" 
                    style=" display: flex; flex-wrap: wrap; width: {{widthPx}}px; height: {{heightImagePx}}px;" />
            </div>
        </div>
    </div>
    <div class="hstack justify-content-between" style="margin-top: 1rem; padding-left: 3px; padding-right: 3px;">
        <div class=" hstack gap-2">
            <input type="file" accept="image/png" style="display: none;" class="file-input"
                (change)="uploadSignature($event)" #fileUpload>
            <button class="btn btn-danger" style="text-align: center; " (click)="fileUpload.click()">
                <div style="display: inline-flex; ">
                    <i class="ri-upload-2-fill me-1 align-bottom"></i>
                    <div style="text-align: center;" i18n="@@UpdateProfile_eSignature_SignatureUpload">Upload</div>
                </div>
            </button>
            <div style="padding-left: 5px;" *ngIf="!signaturefileName"
                i18n="@@UpdateProfile_eSignature_SignatureNotUploaded"> No signature
                uploaded.</div>
            <div style="padding-left: 5px;">{{signaturefileName}}</div>
        </div>
        <div class=" hstack gap-2">
            <button type="button" class="btn btn-soft-danger" id="add-btn" i18n="@@" (click)="clearSig()">Clear</button>
            <button type="button" class="btn btn-success" id="add-btn" i18n="@@" (click)="save()">Submit</button>
        </div>


    </div>
</div>